module.exports = "/images/GC-What we do-03.jpg";